import { useToast } from '@chakra-ui/react';
import * as _ from 'lodash';
import React from 'react';

import { useCreateThreadActionMutation } from './mutations/CreateThreadAction.gql.generated';
import {
  BaseThreadFragmentFragmentGQLType,
  ThreadActionGQLType,
} from '../../../types/dashboard-core-gqlTypes.generated.d';
import { IconButtonV2 } from '~/packages/common-frontend/components/IconButton';
import { Icon } from '~/packages/common-frontend/components/icons';

// Helpers
const throttle = _.throttle((callback: () => Promise<void>) => callback(), 500);

// Exports
type ResolveThreadButtonProps = {
  thread: BaseThreadFragmentFragmentGQLType;
  onClick?: (action: ThreadActionGQLType) => void;
};
export const ResolveThreadButton = ({
  thread,
  onClick,
}: ResolveThreadButtonProps) => {
  const toast = useToast();
  const [createThreadActionMutation] = useCreateThreadActionMutation();
  return (
    <IconButtonV2
      aria-label={thread.resolved ? 'Reopen Thread' : 'Resolve Thread'}
      variant="primary-muted"
      colorScheme="gray"
      isActive={thread.resolved}
      size="sm"
      icon={<Icon icon="circle-check" size="0.75rem" />}
      IconButtonProps={{
        height: '1.5rem',
        width: '1.5rem',
        minWidth: '1.5rem',
      }}
      onClick={() => {
        throttle(async () => {
          try {
            const action = thread.resolved ? 'open' : 'resolve';
            await createThreadActionMutation({
              variables: {
                threadId: thread.threadId,
                action,
              },
            });
            onClick?.(action);
          } catch (error) {
            toast({
              title: thread.resolved
                ? 'Failed to reopen thread'
                : 'Failed to resolve thread',
              status: 'error',
              position: 'top',
            });
          }
        });
      }}
    />
  );
};
